import React from 'react';
import './contactUs.style.css';
import SEO from '../../SEO';

const ContactUs: React.FC = () => {
    return (
        <>
            <SEO 
                title="Contact Wild Chips Poker - Get in Touch"
                description="Need help or have questions about Wild Chips Poker? Contact our support team via email. We're here to assist you with any inquiries about our jungle-themed poker game."
                keywords="contact wild chips poker, poker game support, poker game help, wild chips contact, poker game assistance"
                ogImage="/images/bgContact-min.png"
                canonicalUrl="https://wildchipspoker.com/contact"
            />
            <div className="all-pages-padding contactUs-container">
                <div className="contactUs-contact-section">
                    <h2>Contact Us</h2>
                    <p>Have questions or need assistance? Email us at: <a className="contactUs-email"   href="mailto:wildchipspoker@gmail.com">wildchipspoker@gmail.com</a></p>
                </div>
            </div>
        </>
    );
};

export default ContactUs;

